var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordsTemplatesB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6825 5.87037C19.6825 5.2874 19.2135 4.81481 18.6349 4.81481H9.03175C8.45316 4.81481 7.98413 4.34223 7.98413 3.75926V3.05556C7.98413 2.47259 7.51509 2 6.93651 2H2.04762C1.46903 2 1 2.47259 1 3.05556V19.9444C1 20.5274 1.46904 21 2.04762 21H2.57143H4.14286M4.14286 21H21.9524C22.531 21 23 20.5274 23 19.9444V6.92593C23 6.34296 22.531 5.87037 21.9524 5.87037H16.8889C16.4067 5.87037 16.0159 6.26419 16.0159 6.75V6.62963C16.0159 7.2126 15.5468 7.68518 14.9683 7.68518H5.19048C4.61189 7.68518 4.14286 8.15777 4.14286 8.74074V21ZM14.4444 10.7315V12.1389C14.4444 12.3332 14.6008 12.4907 14.7937 12.4907H16.1905C16.3833 12.4907 16.5397 12.6483 16.5397 12.8426V14.6019C16.5397 14.7962 16.3833 14.9537 16.1905 14.9537H14.7937C14.6008 14.9537 14.4444 15.1112 14.4444 15.3056V16.537C14.4444 16.7314 14.2881 16.8889 14.0952 16.8889H12.5238C12.3309 16.8889 12.1746 16.7314 12.1746 16.537V15.3056C12.1746 15.1112 12.0183 14.9537 11.8254 14.9537H10.4286C10.2357 14.9537 10.0794 14.7962 10.0794 14.6019V12.8426C10.0794 12.6483 10.2357 12.4907 10.4286 12.4907H11.8254C12.0183 12.4907 12.1746 12.3332 12.1746 12.1389V10.7315C12.1746 10.5372 12.3309 10.3796 12.5238 10.3796H14.0952C14.2881 10.3796 14.4444 10.5372 14.4444 10.7315Z",
    stroke: "#2778FA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordsTemplatesB);
export default __webpack_public_path__ + "static/media/RecordsTemplates_b.7181115ff30252dcc297f3b18a26ec2a.svg";
export { ForwardRef as ReactComponent };